const MONTHS_GENITIVE = [
  'января',
  'февраля',
  'марта',
  'апреля',
  'мая',
  'июня',
  'июля',
  'августа',
  'сентября',
  'октября',
  'ноября',
  'декабря',
];

const MONTHS_NOMINATIVE = [
  'Январь',
  'Февраль',
  'Март',
  'Апрель',
  'Май',
  'Июнь',
  'Июль',
  'Август',
  'Сентябрь',
  'Октябрь',
  'Ноябрь',
  'Декабрь',
];

function parseDay(day: string): Date | null {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(day);
  if (!match) return null;
  return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
}

export function monthLabel(yearMonth: string): string {
  const [year, month] = yearMonth.split('-').map(Number);
  return `${MONTHS_NOMINATIVE[month - 1]} ${year}`;
}

export function formatPeriodDay(day: string): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(day);
  if (!match) return day;
  return `${Number(match[3])} ${MONTHS_GENITIVE[Number(match[2]) - 1]} ${match[1]}`;
}

export function formatPeriodRange(from: string, to: string): string {
  if (!from || !to) return '';
  if (from === to) return formatPeriodDay(from);
  const fromDate = parseDay(from);
  const toDate = parseDay(to);
  if (!fromDate || !toDate) return `${from} — ${to}`;
  if (fromDate.getFullYear() === toDate.getFullYear()) {
    const fromMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(from);
    const toMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(to);
    if (!fromMatch || !toMatch) return `${formatPeriodDay(from)} — ${formatPeriodDay(to)}`;
    return `${Number(fromMatch[3])} ${MONTHS_GENITIVE[Number(fromMatch[2]) - 1]} — ${Number(toMatch[3])} ${MONTHS_GENITIVE[Number(toMatch[2]) - 1]} ${fromMatch[1]}`;
  }
  return `${formatPeriodDay(from)} — ${formatPeriodDay(to)}`;
}
